// extracted by mini-css-extract-plugin
export default {"link":"PrimaryLink___style-module__link___CtM4E","active":"PrimaryLink___style-module__active___3sAYW","clicked":"PrimaryLink___style-module__clicked___2e1dH"};